import script from "./ElementProgressTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementProgressTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./ElementProgressTableLoader.vue?vue&type=style&index=0&id=672f1a97&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672f1a97"]])

export default __exports__